import { FC, PropsWithChildren, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, IconButton } from "@mui/material";
import Info from "../../../../assets/icons/info-icon.svg";

import { useAsu } from "@framework/provider-asu";

import { StyledButton } from "../../styled/button";

export interface IInfoDialogButton extends Partial<DialogProps> {
  title: string;
}

export const InfoDialogButton: FC<PropsWithChildren<IInfoDialogButton>> = props => {
  const { children, title, maxWidth = "sm" } = props;

  const { isLoading } = useAsu();

  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton onClick={handleOpen} disabled={isLoading} sx={{ svg: { color: "#0042B0" } }}>
        <Info width={24} height={24} />
      </IconButton>

      <Dialog fullWidth maxWidth={maxWidth} onClose={handleClose} open={open}>
        <DialogTitle id="reports-dialog-title" sx={{ fontWeight: "700" }}>
          <FormattedMessage id={title} />
        </DialogTitle>
        <DialogContent id="reports-dialog-content">{children}</DialogContent>
        <DialogActions>
          <StyledButton onClick={handleClose} sx={{ minWidth: 80, mb: 1, mr: 2 }}>
            <FormattedMessage id="form.buttons.ok" />
          </StyledButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
